import { createTheme } from '@mui/material/styles'
import { baseTheme } from './baseTheme'

export const lightTheme = createTheme({
  ...baseTheme,
  zIndex: {
    // These have been changed from 9997^ because notistack snackbars appear to be hardcoded at zIndex 1400, and
    // the drawer/navigation menu was covering most of the notifications with the recent mobile friendliness changes.
    // "snackbar: 1400" is declared here for consistency between our MUI theme and notistack. MJS 5/3/2024
    appBar: 1397,
    drawer: 1398,
    modal: 1399,
    snackbar: 1400,
    fab: 1400 // What is this? MJS
  },
  palette: {
    mode: 'light',
    background: {
      default: `#efefef`
    },
    primary: {
      main: '#2196f3'
      // light: '#A0CCF2',
      // dark: '#010D26'
    },
    secondary: {
      main: '#f50057',
      light: '#f73378',
      dark: '#ab003c'
    },
    success: {
      main: '#43a047',
      light: '#68b36b',
      dark: '#2e7031'
    },
    warning: {
      main: '#fdd835',
      light: '#fddf5d',
      dark: '#b19725'
    }
    // error: {
    //   main: '#ff1744',
    //   light: '#ff4569',
    //   dark: '#b2102f'
    // }
  }
})
